import sanitizeHtml from "sanitize-html";

export const sanitizeEmailHTMLContent = (html: string) =>
  sanitizeHtml(html, {
    allowedTags: ["a", "strong", "b", "em", "i", "u", "br", "p", "img", "div", "span", "blockquote", "code"],
    allowedAttributes: {
      a: ["href", "target", "rel", "style"],
      img: ["src", "alt", "width", "height", "style"],
      div: ["style"],
      span: ["style"],
      p: ["style"],
      strong: ["style"],
      b: ["style"],
      em: ["style"],
      i: ["style"],
      u: ["style"],
    },
    // Automatically add security attributes to external links
    transformTags: {
      a: (tagName, attribs) => {
        const href = attribs.href || "";
        // Add target="_blank" and security attributes for external links
        if (href.startsWith("http://") || href.startsWith("https://")) {
          return {
            tagName,
            attribs: {
              ...attribs,
              target: "_blank",
              rel: "noopener noreferrer",
            },
          };
        }
        return { tagName, attribs };
      },
    },
    // Allow only safe protocols for images
    allowedSchemesByTag: {
      img: ["http", "https", "data"],
    },
  });
